/*
 Copyright (C) 2015 Ivan Maeder
 This program is free software: you can redistribute it and/or modify
 it under the terms of the GNU General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.
 This program is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU General Public License for more details.
 You should have received a copy of the GNU General Public License
 along with this program.  If not, see <http://www.gnu.org/licenses/>.
 -
 Prevent computer or display sleep with HTML5/JavaScript. Include this
 file then use the following:
     sleep.prevent()
     sleep.allow()
 */
let _video;

function _init() {
  _video = document.createElement('video');
  _video.setAttribute('width', '10');
  _video.setAttribute('height', '10');
  _video.style.position = 'absolute';
  _video.style.top = '-10px';
  _video.style.left = '-10px';

  const source_mp4 = document.createElement('source');
  source_mp4.setAttribute(
    'src',
    'https://namastream-api-production.s3-us-west-1.amazonaws.com/muted-blank.mp4'
  );
  source_mp4.setAttribute('type', 'video/mp4');
  _video.appendChild(source_mp4);

  const source_ogg = document.createElement('source');
  source_ogg.setAttribute(
    'src',
    'https://namastream-api-production.s3-us-west-1.amazonaws.com/resources_muted-blank.ogv'
  );
  source_ogg.setAttribute('type', 'video/ogg');
  _video.appendChild(source_ogg);

  document.body.appendChild(_video);
}

function prevent() {
  if (!_video) {
    _init();
  }

  _video.setAttribute('loop', 'loop');
  _video.setAttribute('playsinline', '');
  _video.play();
}

function allow() {
  if (!_video) {
    return;
  }

  _video.removeAttribute('loop');
  _video.pause();
}

export default {
  prevent,
  allow,
};
